import { GeometryClassDefinition } from '@/features/custom-shared/types/editor/classes';
import { WireframeProperties } from '@/features/custom-shared/types/editor/common';
import { GeometryClassInstance } from '@/features/custom-shared/types/editor/instances';
import { DefaultCName } from '@/types/custom';

import { CONSTANTS } from './constants';

export const DEFAULT_GEOMETRY_CLASS_DEFINITION: GeometryClassDefinition<DefaultCName> =
  {
    name: 'Uncategorized',
    displayProperties: {
      order: 10000,
      name: 'Uncategorized',
      icon: 'box',
      visible: true,
      material: {
        color: '#a8a29e',
        opacity: 0.3,
      },
    },
    classProperties: {},
    classPropertiesSchema: {},
    propertiesSchema: {},
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  };

export const DEFAULT_GEOMETRY_INSTANCE: GeometryClassInstance<DefaultCName> = {
  className: 'Uncategorized',
  displayProperties: {
    name: 'Uncategorized item',
  },
  properties: {},
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
};

export const DEFAULT_WIREFRAME_PROPS: Required<WireframeProperties> = {
  mode: 'edges',
  color: `#${CONSTANTS.colors.edgesColor.getHexString()}`,
};
